<template>
    <div class="view pa24">
      <el-form :model="serchParams" class="demo-form-inline" :inline="true">
            <el-row style="padding-top: 20px;">
                <el-form-item label="一级代理商" label-width="100px" label-position="left" class="fromItem" prop="dlId">
                  <el-select v-model="serchParams.dlId" placeholder="请选择" @change="selectDl" clearable filterable>
                    <el-option
                      v-for="item in dlOptions"
                      :key="item.id"
                      :label="item.dealerName"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="二级分销商" label-width="100px" label-position="left" class="fromItem" @change="selectDealer" prop="dealerId" v-if="type==2">
                  <el-select v-model="serchParams.dealerId" placeholder="请选择" clearable filterable>
                    <el-option
                        v-for="item in dealerOptions"
                        :key="item.id"
                        :label="item.dealerName"
                        :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-button type="primary" @click="search">搜索</el-button>
                <el-button @click="resetSearch">重置</el-button>
              <el-dropdown trigger="click" style="margin-left: 10px;" @command="exportDlTj">
                <span class="el-dropdown-link">
                  <el-button
                             element-loading-text="导出中..." type="warning">导出<i class="el-icon-caret-bottom el-icon--right"></i></el-button>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item class="clearfix" command="1">
                    统计数据
                  </el-dropdown-item>
                  <el-dropdown-item class="clearfix" command="0">
                    详细数据
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

            </el-row>
        </el-form>
      <commonTable
        :tableData="tableData"
        :total="total"
        :currentPage="pageNum"
        :loading="tableLoading"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      >
        <template v-slot:table>
          <el-table-column
              align="center"
              label="一级代理商"
          >
            <template slot-scope="scope">
              {{scope.row.dlName}}
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              label="二级分销商"
              v-if="type == 2"
          >
            <template slot-scope="scope">
              {{scope.row.dealerName}}
            </template>
          </el-table-column>
          <el-table-column
              prop="className"
              align="center"
              label="库存数"
          >
            <template slot-scope="scope">
              {{scope.row.stockBoxNum||'0'}}箱+{{scope.row.stockPackNum||'0'}}盒
            </template>
          </el-table-column>
          <el-table-column
              prop="className"
              align="center"
              label="库存盒数"
          >
            <template slot-scope="scope">
              {{scope.row.stockAllPackNum||'0'}}盒
            </template>
          </el-table-column>
          <el-table-column
            prop="handle"
            align="center"
            label="入库数"
          >
            <template slot-scope="scope">
              {{scope.row.inBoxNum||'0'}}箱+{{scope.row.inPackNum||'0'}}盒
            </template>
          </el-table-column>
          <el-table-column
              prop="handle"
              align="center"
              label="入库盒数"
          >
            <template slot-scope="scope">
              {{scope.row.inAllPackNum||'0'}}盒
            </template>
          </el-table-column>
          <el-table-column
              prop="number"
              align="center"
              label="出库数"
          >
            <template slot-scope="scope">
              {{scope.row.outBoxNum||'0'}}箱+{{scope.row.outPackNum||'0'}}盒
            </template>
          </el-table-column>
          <el-table-column
              prop="handle"
              align="center"
              label="出库盒数"
          >
            <template slot-scope="scope">
              {{scope.row.outAllPackNum||'0'}}盒
            </template>
          </el-table-column>
          <el-table-column align="center"
                           label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="goDetail(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </template>
      </commonTable>

      <el-drawer
          title="详情"
          :visible.sync="classTable"
          direction="rtl"
          append-to-body
          size="50%">
        <el-table :data="classData" >
          <el-table-column property="className" label="产品名称" align="center"></el-table-column>
          <el-table-column property="name" label="库存数" align="center">
            <template slot-scope="scope">
              {{scope.row.boxNum||'0'}}箱+{{scope.row.packNum||'0'}}盒
            </template>
          </el-table-column>
          <el-table-column property="name" label="库存盒数" align="center">
            <template slot-scope="scope">
              {{scope.row.stockAllPackNum||'0'}}盒
            </template>
          </el-table-column>
          <el-table-column property="address" label="入库数" align="center">
            <template slot-scope="scope">
              {{scope.row.inBoxNum||'0'}}箱+{{scope.row.inPackNum||'0'}}盒
            </template>
          </el-table-column>
          <el-table-column property="address" label="入库盒数" align="center">
            <template slot-scope="scope">
              {{scope.row.inAllPackNum||'0'}}盒
            </template>
          </el-table-column>
            <el-table-column property="address" label="出库数" align="center">
              <template slot-scope="scope">
                {{scope.row.outBoxNum||'0'}}箱+{{scope.row.outPackNum||'0'}}盒
              </template>
            </el-table-column>
          <el-table-column property="address" label="出库盒数" align="center">
            <template slot-scope="scope">
              {{scope.row.outAllPackNum||'0'}}盒
            </template>
          </el-table-column>
          <el-table-column align="center"
                           label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="detail(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-drawer>



      <distribution-detail-home ref="detailHome"></distribution-detail-home>
    </div>
  </template>
  <script>
  import commonTable from "@/components/common/commonTable";
  import DistributionDetailHome from "@/pages/warehouseLog/components/distributionDetailHome.vue";
import {crkDealerTj,getDealerList,exportDlTj,classDetail} from '@/api/crk'
  export default {
    name: "dealerList",
    components: {
      commonTable,
      DistributionDetailHome
    },
    data() {
      return {
          tableData: [],
          pageSize: 10,
          pageNum: 1,
          total: 0,
          serchParams: {
            dlId: '',
            dealerId:'',
            timeRange: []
          },
          dlOptions:[],
          dealerOptions:[],
        fullscreenLoading:false,
        tableLoading:false,
        classTable:false,
        classData:[],
        detailDealerId:'',
        loadingModel:''
      };
    },
    props:{
      type:Number
    },
    created() {
      // 获取所有代理商、经销商列表
      this.getDealerList()
    },
    mounted() {
      this.getList()
    },
    methods: {
        handleSizeChange(num) {
          this.pageSize = num;
          this.pageNum = 1;
          this.getList();
        },
        handleCurrentChange(num) {
          this.pageNum = num;
          this.getList();
        },
        getDealerList() {
          let params={
            type:1,
          }
          getDealerList(params).then(res => {
            this.dlOptions = res.data
          })
        },
      selectDealer(val){
        this.serchParams.dealerId = val
      },
        selectDl(val){
          this.dealerOptions = []
          this.serchParams.dealerId = ''
          this.serchParams.dlId = val
          if( val === '' ){
            return
          }

          let params={
            type:2,
            parentId: val
          }
          getDealerList(params).then(res => {
            this.dealerOptions = res.data
          })
        },
        search() {
          this.pageNum = 1
          this.getList()
        },
        resetSearch() {
          this.serchParams.dlId = ''
          this.serchParams.dealerId = ''
          this.serchParams.timeRange = []
          this.dealerOptions = []
          this.pageNum = 1
          this.getList()
        },
        getList() {
          this.tableLoading = true
          let params={
            pageNum: this.pageNum,
            pageSize: this.pageSize,
            type:this.type,
            dealerId: this.type==1?this.serchParams.dlId:this.serchParams.dealerId,
            parentId:this.type==2?this.serchParams.dlId:'',
          }
          crkDealerTj(params).then(res => {
            this.tableData = res.data.list
            this.total = res.data.total
          }).finally(() => {
            this.tableLoading = false
          })
        },
      exportDlTj(command){
        this.loadingModel = this.$loading({
          lock: true,
          text: '导出中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        //统计数据
        let params={
          type:this.type,
          dealerId: this.type==1?this.serchParams.dlId:this.serchParams.dealerId,
          parentId:this.type==2?this.serchParams.dlId:'',
          exportDetail:command==1?false:true
        }
        this.fullscreenLoading = true;
        exportDlTj(params).then(result=>{
          this.closeLoading()
          const url = window.URL.createObjectURL(result.data);
          const temp =result.fileName.split(";")[1].split("filename=")[1];
          const fileName = decodeURIComponent(temp)
          const link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', fileName );
          document.body.appendChild(link);
          link.click();
        }).catch(e=>{
          this.closeLoading()
          this.$message.error(e.message)
        })
      },
      goDetail(row){
          this.detailDealerId = row.dealerId
        let params={
          type:this.type,
          dealerId: row.dealerId,
        }
        classDetail(params).then(res=>{
          this.classData = res.data
          this.classTable = true
        })
      },
      detail(){
        this.$refs.detailHome.open(this.detailDealerId)
      },
      closeLoading(){
        if (this.loadingModel){
          this.loadingModel.close()
        }
      }
    }
  }
  </script>

  <style lang="scss" scoped>
      .greenTag{
        color: #fff;
        background: #08A89B;
        border-radius: 6px;
        padding: 3px 5px;
        overflow: hidden;

      }
      .redTag{
        background: #e5e5e5;
        color: #f00;
        border-radius: 6px;
        padding: 3px 5px;
        overflow: hidden;
      }
  </style>
